module.exports = __webpack_public_path__ + "static/media/Glasses.3012194a.svg";